module.exports = __webpack_public_path__ + "img/people_green.075635ae.svg";